<div class="customer-program__telemetry-container">
    <avi-alert-group
        *ngIf="error"
        alertType="danger"
        class="customer-program__error-msg"
    >
        {{ error }}
    </avi-alert-group>
    <avi-page-header headerText="{{ globalL10nKeys.customerProgramLabel | vtranslate }}"></avi-page-header>
    <avi-card>
        <avi-card_header>
            <cds-icon
                shape="line-chart"
                size="20"
                status="success"
            ></cds-icon>
            <span class="customer-program__telemetry-header">
              {{ l10nKeys.sharedDataLabel | vtranslate }}
            </span>
        </avi-card_header>
        <avi-card_body>
            <div class="customer-program__data-row">
                <div class="customer-program__version">
                    <span class="customer-program__data-label">
                        {{ globalL10nKeys.versionLabel | vtranslate }}
                    </span>
                    <div class="customer-program__upper-values">
                        {{ telemetryData?.version ?? "-" }}
                    </div>
                </div>
                <div class="customer-program__timestamp">
                    <span class="customer-program__data-label">
                        {{ l10nKeys.dataLastSentLabel | vtranslate }}
                    </span>
                    <div class="customer-program__upper-values">
                        {{ telemetryData?.timestamp ?? "-" }}
                    </div>
                </div>
            </div>
            <hr class="customer-program__divider" />
            <div class="customer-program__grid-conatiner">
                <div class="customer-program__grid-col">
                    <span class="customer-program__data-label">
                        {{ l10nKeys.cloudTypeCountLabel | vtranslate }}
                    </span>
                    <div class="customer-program__value">
                        {{ telemetryData?.cloud_type_count?.CLOUD_NONE ?? "-" }}
                    </div>
                </div>
                <div class="customer-program__grid-col">
                    <span class="customer-program__data-label">
                        {{ l10nKeys.gslbSiteCountLabel | vtranslate }}
                    </span>
                    <div class="customer-program__value">
                        {{ telemetryData?.gslb_sites_count ?? "-" }}
                    </div>
                </div>
                <div class="customer-program__grid-col">
                    <span class="customer-program__data-label">
                        {{ l10nKeys.gslbServiceCountLabel | vtranslate }}
                    </span>
                    <div class="customer-program__value">
                        {{ telemetryData?.gslb_service_count ?? "-" }}
                    </div>
                </div>
                <div class="customer-program__grid-col">
                    <span class="customer-program__data-label">
                        {{ l10nKeys.vsCountLabel | vtranslate }}
                    </span>
                    <div class="customer-program__value">
                        {{ telemetryData?.vs_counts ?? "-" }}
                    </div>
                </div>
                <div class="customer-program__grid-col">
                    <span class="customer-program__data-label">
                        {{ l10nKeys.vsWithWafCountLabel | vtranslate }}
                    </span>
                    <div class="customer-program__value">
                        {{ telemetryData?.waf_vs_count ?? "-" }}
                    </div>
                </div>
                <div class="customer-program__grid-col">
                    <span class="customer-program__data-label">
                        {{ l10nKeys.serviceEngineCountLabel | vtranslate }}
                    </span>
                    <div class="customer-program__value">
                        {{ telemetryData?.se_count ?? "-" }}
                    </div>
                </div>
            </div>
        </avi-card_body>
        <avi-card_footer>
            <cds-button
                action="flat"
                (click)="downloadFullMetrics()"
                size="sm"
                [disabled]="!telemetryData"
            >
                {{ l10nKeys.downloadFullMetricsLabel | vtranslate | uppercase }}
            </cds-button>
        </avi-card_footer>
    </avi-card>
</div>
